module.exports = __webpack_public_path__ + "static/media/chessBoardGameIMg.eb93228f.png";